import React from 'react';
import {
	DocumentType,
	useMedicalHistoryDocumentsQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import PatientMedicalHistoryVersion, {
	PatientMedicalHistoryVersionItem,
} from './PatientMedicalHistoryVersion';
// @ts-ignore
import styles from './PatientMedicalHistoryVersions.module.scss';
import Legend from '../../../Base/Components/Legend/Legend';
import { LegendItemScheme } from '../../../Base/Components/Legend/LegendItem';

interface Props {
	medicalHistoryDocumentId: string;
	patientId: string;
}

const patientMedicalHistoryLegend: LegendItemScheme[] = [
	{
		title: 'component.patientMedicalHistoryVersions.legend.newVersion',
		color: '#acf2bd',
	},
	{
		title: 'component.patientMedicalHistoryVersions.legend.oldVersion',
		color: '#fdb8c0',
	},
];

const PatientMedicalHistoryVersions: React.FC<Props> = ({
	medicalHistoryDocumentId,
	patientId,
}) => {
	const { data, isLoading } = useMedicalHistoryDocumentsQuery({
		where: {
			id: medicalHistoryDocumentId,
			userId: patientId,
			type: DocumentType.MedicalHistory,
		},
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Legend items={patientMedicalHistoryLegend} />
			{data?.documentVersions?.data
				?.filter(item => item.previousVersionDocumentId)
				?.map(item => (
					<PatientMedicalHistoryVersion
						item={item as PatientMedicalHistoryVersionItem}
						key={item.id}
					/>
				))}
		</div>
	);
};

export default PatientMedicalHistoryVersions;
